import { ReactElement, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AdditionalFields, Page, PageSpinner } from '@ohpen/enso-ui';
import { useConfigReady, useFeatureToggle } from '@pmp/hooks';
import { PRODUCTS_ENTITY_LIST_NAMES, PRODUCTS_VALUE_LIST_NAMES, ProductsList, ProductsListComponent } from '@pmp/components';
import { useAdditionalFieldsStore, useValueListsStore } from '@pmp/stores';
import { ActionEntityType } from '@pmp/api';

export const ProductsPage = (): ReactElement => {
  const productsListRef = useRef<ProductsListComponent | null>(null);
  const { valueLists, getValueLists } = useValueListsStore();
  const { isLoadingAdditionalFields, getAdditionalFields } = useAdditionalFieldsStore();
  const [additionalFields, setAdditionalFields] = useState<AdditionalFields | null>(null);
  const isConfigReady = useConfigReady();
  const enableAdditionalFields = useFeatureToggle(['enableAdditionalFields']);
  const { t } = useTranslation();

  useEffect(() => {
    getValueLists({ fetchIfMissing: PRODUCTS_VALUE_LIST_NAMES, alwaysFetch: PRODUCTS_ENTITY_LIST_NAMES });
  }, [getValueLists]);

  useEffect(() => {
    if (isLoadingAdditionalFields || additionalFields) return;
    getAdditionalFields(ActionEntityType.PRODUCTS).then(additionalFields => {
      setAdditionalFields(additionalFields);
    });
  }, [additionalFields, enableAdditionalFields, getAdditionalFields, isLoadingAdditionalFields, setAdditionalFields]);

  return (
    <Page>
      <Page.Title>{t('pmp.products.title')}</Page.Title>
      <Page.Content>
        {isConfigReady ? (
          <ProductsList
            ref={productsListRef}
            valueLists={valueLists}
            additionalFields={additionalFields}
            fieldsLoading={isLoadingAdditionalFields}
          />
        ) : (
          <PageSpinner />
        )}
      </Page.Content>
    </Page>
  );
};
